<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 财务管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>记账对账</el-breadcrumb-item>
				<el-breadcrumb-item>资金流水</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.statementType" placeholder="请选择流水类型" @change="queryStatementChange" style="width:130px;">
					<el-option key="" label="请选择流水类型" value=""></el-option>
					<el-option v-for="item in statementTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.financeType" placeholder="请选择财务类型" filterable style="width:130px;">
					<el-option key="" label="请选择财务类型" value=""></el-option>
					<el-option v-for="item in queryFinanceTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.accountType" placeholder="请选择账户类型" filterable style="width:130px;">
					<el-option key="" label="请选择账户类型" value=""></el-option>
					<el-option v-for="item in accountTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.companyName" placeholder="公司名称" class="handle-input mr10" style="width:180px;"></el-input>
				<el-date-picker
					type="datetime"
					placeholder="开始时间"
					v-model="query.tranTimeStart"
					value-format="yyyy-MM-dd HH:mm:SS"
					style="width:185px;"
				></el-date-picker> &nbsp;
				<el-date-picker
					type="datetime"
					placeholder="结束时间"
					v-model="query.tranTimeEnd"
					value-format="yyyy-MM-dd HH:mm:SS"
					style="width:185px;"
				></el-date-picker>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>&nbsp;&nbsp;
				<a href="https://img.zelixin.cn/template/银行流水模板.xlsx" style="font-size:12px;color:#66b1ff">银行流水模板</a>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column prop="statementType" label="流水类型" :formatter="statementTypeFormat" width="80"></el-table-column>
				<el-table-column prop="financeType" label="财务类型" :formatter="financeTypeFormat" width="150"></el-table-column>
				<el-table-column prop="accountType" label="账户类型" :formatter="accountTypeFormat" width="120"></el-table-column>
				<el-table-column prop="companyName" label="对方公司"></el-table-column>
				<el-table-column prop="amount" label="交易金额" width="120"></el-table-column>
				<el-table-column prop="balance" label="余额" width="120"></el-table-column>
				<el-table-column prop="tranTime" label="交易时间" width="160"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
							v-if="controll['edit'] && scope.row.editActive && scope.row.companyName != '合计：'"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show'] && scope.row.companyName != '合计：'"
                        >详情</el-button>
						<el-button
                            type="text"
                            icon="el-icon-delete"
							v-if="controll['delete'] && scope.row.deleteActive && scope.row.companyName != '合计：'"
							class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-upload
					style="float:left"
					class="upload-demo mr10"
					accept=".xls,.xlsx"
					action= "/blob/bank-statement/import-excel"
					:on-success="uploadSuccess"
					:file-list="fileList"
					:show-file-list = "false"
					v-if="controll['import']"
					list-type="picture">
					<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import']">导入流水</el-button>
				</el-upload>
				<el-button
					style="float:left"
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="预览" :visible.sync="previewVisible" fullscreen>
            <el-table
                :data="previewData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				height="500px"
				stripe
            >
                <el-table-column prop="sign" label="借贷标识" width="80"></el-table-column>
				<el-table-column prop="companyName" label="对方公司"></el-table-column>
				<el-table-column prop="bankName" label="对方银行"></el-table-column>
				<el-table-column prop="bankNo" label="对方账号" width="200"></el-table-column>
				<el-table-column prop="financeTypeName" label="交易类型" width="100"></el-table-column>
				<el-table-column prop="amount" label="交易金额" width="100"></el-table-column>
				<el-table-column prop="balance" label="余额" width="100"></el-table-column>
				<el-table-column prop="tranTime" label="交易时间" width="160"></el-table-column>
				<el-table-column prop="purpose" label="摘要" width="150"></el-table-column>
				<el-table-column prop="bankNoSelf" label="本方账号" width="180"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button @click="previewVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">保存</el-button>
            </span>
        </el-dialog>
		
		<!-- 新增弹出框 -->
        <el-dialog title="新增记录" :visible.sync="addVisible" width="40%">
			<el-form ref="form" :model="form" label-width="100px" :rules="addRules">
				<el-form-item label="流水类型: " prop="statementType">
					<el-select v-model="form.statementType" placeholder="请选择流水类型" @change="editStatementChange" style="width:155px;">
						<el-option key="" label="请选择流水类型" value=""></el-option>
						<el-option v-for="item in statementTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="财务类型: " prop="financeType">
					<el-select v-model="form.financeType" placeholder="请选择财务类型" style="width:155px;">
						<el-option key="" label="请选择财务类型" value=""></el-option>
						<el-option v-for="item in editFinanceTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="账户类型: " prop="accountType">
					<el-select v-model="form.accountType" placeholder="请选择账户类型" style="width:155px;">
						<el-option key="" label="请选择账户类型" value=""></el-option>
						<el-option v-for="item in accountTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="对方公司: " prop="companyName">
					<el-input v-model="form.companyName"></el-input>
				</el-form-item>
				<el-form-item label="对方银行: " prop="bankName">
					<el-input v-model="form.bankName"></el-input>
				</el-form-item>
				<el-form-item label="对方账号: " prop="bankNo">
					<el-input v-model="form.bankNo"></el-input>
				</el-form-item>
				<el-form-item label="交易金额: " prop="amount">
					<el-input v-model="form.amount"></el-input>
				</el-form-item>
				<el-form-item label="交易时间: " prop="tranTime">
					<el-date-picker
						type="datetime"
						v-model="form.tranTime"
						value-format="yyyy-MM-dd HH:mm:SS"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="摘要: " prop="purpose">
					<el-input v-model="form.purpose"></el-input>
				</el-form-item>
				<el-form-item style="text-align:right">
					<el-button @click="addVisible = false">取 消</el-button>
					<el-button type="primary" @click="add" v-prevent-re-click>确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		
		<!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible" width="40%">
			<el-form ref="editForm" :model="editData" label-width="100px" :rules="rules">
				<el-form-item label="对方公司: " >
					{{editData.companyName}}
				</el-form-item>
				<el-form-item label="对方银行: " >
					{{editData.bankName}}
				</el-form-item>
				<el-form-item label="对方账号: " >
					{{editData.bankNo}}
				</el-form-item>
				<el-row>
					<el-col :span="12">
						<el-form-item label="交易金额: " >
							￥{{editData.amount}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="交易后余额: " >
							￥{{editData.balance}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="交易时间: " >
							{{editData.tranTime}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="摘要: " >
							{{editData.purpose}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="流水类型: " >
							{{statementTypeFormat(null, null, editData.statementType)}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="账户类型: " >
							{{accountTypeFormat(null, null, editData.accountType)}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="财务类型: " prop="financeType">
					<el-select v-model="editData.financeType" placeholder="请选择财务类型" filterable>
						<el-option key="" label="请选择报财务类型" value=""></el-option>
						<el-option v-for="item in editFinanceTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单日期: " prop="orderTime">
					<el-date-picker
						type="date"
						v-model="editData.orderTime"
						value-format="yyyy-MM-dd"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="备注: " prop="remark">
					<el-input type=textarea :rows=3 v-model="editData.remark"> </el-input>
				</el-form-item>
				<el-form-item style="text-align:right">
					<el-button @click="editVisible = false">取 消</el-button>
					<el-button type="primary" @click="edit" v-prevent-re-click>确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		
		<!-- 详情弹出框 -->
        <el-dialog title="详情" :visible.sync="showVisible" width="40%">
			<el-form ref="show" :model="show" label-width="100px">
				<el-descriptions class="margin-top" title="" :column="1" size="medium" labelStyle="width:160px;" border>
					<el-descriptions-item>
						<template slot="label">
							流水类型
						</template>
						{{statementTypeFormat(null, null, show.statementType)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							财务类型
						</template>
						{{financeTypeFormat(null, null, show.financeType)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							账户类型
						</template>
						{{accountTypeFormat(null, null, show.accountType)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							本方账号
						</template>
						{{show.bankNoSelf}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							对方公司
						</template>
						{{show.companyName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							对方银行
						</template>
						{{show.bankName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							对方账号
						</template>
						{{show.bankNo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							交易金额
						</template>
						￥{{show.amount}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							交易后余额
						</template>
						￥{{show.balance}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							交易时间
						</template>
						{{show.tranTime}}
					</el-descriptions-item>
					<el-descriptions-item v-if="show.orderTime">
						<template slot="label">
							订单日期
						</template>
						{{show.orderTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							摘要
						</template>
						{{show.purpose}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							备注
						</template>
						{{show.remark}}
					</el-descriptions-item>
				</el-descriptions>
			</el-form>
		</el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchBankStatementData, saveBankStatement, getBankStatement, updateBankStatement, deleteBankStatement, saveBankStatementSingle } from '../../../api/index';
export default {
    name: 'bank-statement',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            previewVisible: false,
            pageTotal: 0,
            form: {},
			show: {},
			editData: {},
            idx: -1,
            id: -1,
			showVisible:false,
			editVisible:false,
			addVisible:false,
			fileList:[],
			previewData:[],
			uuid:"",
			statementTypeKV:[{"key":0,"value":"收入"},{"key":1,"value":"支出"}],
			accountTypeKV:[{"key":0,"value":"公账"},{"key":1,"value":"微信/支付宝"},{"key":2,"value":"现金"}],
			queryFinanceTypeKV:[],
			editFinanceTypeKV:[],
			rules: {
                financeType: [{ required: true, message: '请选择财务类型', trigger: 'blur' }],
				remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
			},
			addRules: {
				statementType: [{ required: true, message: '请选择流水类型', trigger: 'blur' }],
				financeType: [{ required: true, message: '请选择财务类型', trigger: 'blur' }],
				accountType: [{ required: true, message: '请选择账户类型', trigger: 'blur' }],
				companyName: [{ required: true, message: '请输入对方公司', trigger: 'blur' }],
				amount: [{ required: true, message: '请输入交易金额', trigger: 'blur' }],
				tranTime: [{ required: true, message: '请选择交易时间', trigger: 'blur' }]
			},
			controll:{}
        };
    },
    created() {
		this.controll = getControll("bank-statement");
        this.getData();
    },
    methods: {
		//流水类型
		statementTypeFormat(row, column, cellValue) {
			let arrivalStatusConfig = {"0":"收入", "1":"支出"};
			return arrivalStatusConfig[cellValue];
		},
		//财务类型
		financeTypeFormat(row, column, cellValue) {
			let statusConfig = {"10":"货款","11":"采购退款","12":"利息","13":"借款","14":"货款拆分平账","15":"补贴","16":"社保退费","17":"公积金退费","18":"技术服务费","20":"采购款","21":"货款退款","22":"工资","23":"报销","24":"还款","25":"手续费","26":"社保","27":"增值税及附加税","28":"采购款拆分平账","29":"证书服务费","30":"年终奖","31":"个税","32":"住房公积金","33":"银行年费","34":"企业服务费","0":"其他"};
			return statusConfig[cellValue];
		},
		accountTypeFormat(row, column, cellValue) {
			let accountTypeConfig = {"0":"公账","1":"微信/支付宝","2":"现金"};
			return accountTypeConfig[cellValue];
		},
        // 获取数据
        getData() {
            fetchBankStatementData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
					let amount = 0;
					let summary = {};
					summary["companyName"] = "合计：";
					for (var i = 0; i < res.data.records.length; i++) {
						amount += res.data.records[i]["amount"];
					}
					summary["amount"] = amount;
					if (res.data.tatistics) {
						summary["balance"] = "总计：";
						summary["tranTime"] = res.data.tatistics["amount"];
					}
					this.tableData.push(summary);
				} else {
					this.$message.error(res.message);
				}
            });
        },
		queryStatementChange(value) {
			this.queryFinanceTypeKV = this.changeStatement(value);
		},
		editStatementChange(value) {
			this.editFinanceTypeKV = this.changeStatement(value);
		},
		changeStatement(value) {
			if (value === "") {
				return [];
			}
			if (value == 0) {
				return [{"key":10,"value":"货款"},{"key":11,"value":"采购退款"},{"key":14,"value":"货款拆分平账"},{"key":12,"value":"利息"},{"key":13,"value":"借款"},{"key":15,"value":"补贴"},{"key":16,"value":"社保退费"},{"key":17,"value":"公积金退费"},{"key":18,"value":"技术服务费"},{"key":0,"value":"其他"}];
			} else {
				return [{"key":20,"value":"采购款"},{"key":21,"value":"货款退款"},{"key":28,"value":"采购款拆分平账"},{"key":22,"value":"工资"},{"key":23,"value":"报销"},{"key":24,"value":"还款"},{"key":25,"value":"手续费"},{"key":26,"value":"社保"},{"key":27,"value":"增值税及附加税"},{"key":29,"value":"证书服务费"},{"key":30,"value":"年终奖"},{"key":31,"value":"个税"},{"key":32,"value":"住房公积金"},{"key":33,"value":"银行年费"},{"key":34,"value":"企业服务费"},{"key":0,"value":"其他"}];
			}
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		handleAdd() {
			this.addVisible = true;
			this.form = {};
			this.editFinanceTypeKV = [];
		},
		add() {
			this.$refs.form.validate(valid => {
				if (valid){
					this.form["balance"] = 0;
					saveBankStatementSingle(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.addVisible = false;
							this.getData();
						} else {
							this.$message.error(res.message);
						}
					}); 
				} else {
					this.$message.error('信息填写不完整！');
				}
            });
		},
        // 保存编辑
        save() {
			saveBankStatement(this.uuid).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.previewVisible = false;
					this.getData();
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			});
        },
		edit() {
			this.$refs.editForm.validate(valid => {
				if (valid){
					let data = {};
					data["id"] = this.editData["id"];
					data["accountType"] = this.editData["accountType"];
					data["financeType"] = this.editData["financeType"];
					data["remark"] = this.editData["remark"];
					data["orderTime"] = this.editData["orderTime"];
					updateBankStatement(data).then(res => {
						if (res.code == 0) {
							this.$message.success('更新成功！');
							this.getData();
							this.editVisible = false;
						} else {
							this.$message.error(res.message);
						}
					}); 
				} else {
					this.$message.error('信息填写不完整！');
				}
            });
		},
		// 编辑操作
        handleEdit(index, row) {
			this.idx = index;
            getBankStatement(row.id).then(res => {
				if (res.code == 0) {
					this.editStatementChange(res.data.statementType);
					this.editData = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		// 详情操作
        handleShow(index, row) {
			getBankStatement(row.id).then(res => {
				if (res.code == 0) {
					this.show = res.data;
					this.showVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		handleDelete(index, row) {
			// 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteBankStatement([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		uploadSuccess(response, file, fileList) {
			if (response.code == 0 ) {
				this.previewData = response.data.obj;
				this.uuid = response.data.uuid;
				this.previewVisible = true;
			} else {
				this.$message.error(response.message);
			}
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
